import { createSlice, PayloadAction } from "@reduxjs/toolkit";

export interface AssessmentFlow {
    currentFlow: number;
    flows: Flow[];
    silentTimeout: number;
}

export interface Flow {
    name: string;
    path: string;
    list: number;
}

export const initialState: AssessmentFlow = {
    currentFlow: 0,
    flows: [],
    silentTimeout: 0
};

const assessmentFlowSlice = createSlice({
    name: "assessmentFlow",
    initialState,
    reducers: {
        setAssessmentFlow(state, action: PayloadAction<Flow[]>) {
            state.flows = action.payload;
        },
        updateCurrentFlow(state) {
            state.currentFlow++;
        },
        setSiltentTimeout(state, action: PayloadAction<number>) {
            state.silentTimeout = action.payload;
        }
    }
});

export const { setAssessmentFlow, updateCurrentFlow, setSiltentTimeout } = assessmentFlowSlice.actions;

export default assessmentFlowSlice.reducer;
